import { memo } from 'react';

import TypographyCompo from '../../../components/Comman/TypographyCompo';
import { DASHBOARD_COLORS } from '../styles/colors';
import { STATUS_BADGE_MAP } from '../constants';

export const KpiCard = memo(function KpiCard({ label, value, sub, variant, icon }) {
  return (
    <div className={`kpi kpi-${variant}`}>
      <div className="kpi-top">
        <TypographyCompo className="kpi-label" color={DASHBOARD_COLORS.text2} component="div">
          {label}
        </TypographyCompo>
        <div className="kpi-icon-wrap">{icon}</div>
      </div>
      <TypographyCompo className="kpi-val" color="inherit" component="div">
        {value}
      </TypographyCompo>
      <TypographyCompo className="kpi-sub" color={DASHBOARD_COLORS.text2} component="div">
        {sub}
      </TypographyCompo>
    </div>
  );
});

export const KpiGrid = memo(function KpiGrid({ items, columns = 'g10' }) {
  return (
    <div className={columns}>
      {items.map((item) => (
        <KpiCard key={item.key} {...item} />
      ))}
    </div>
  );
});

export const SectionHeader = memo(function SectionHeader({
  icon,
  iconBackground,
  title,
  count,
}) {
  return (
    <div className="section-head">
      <div className="section-head-icon" style={{ background: iconBackground }}>
        {icon}
      </div>
      <TypographyCompo
        className="section-head-title"
        color={DASHBOARD_COLORS.text2}
        component="span"
      >
        {title}
      </TypographyCompo>
      {count ? (
        <TypographyCompo
          className="section-head-count"
          color={DASHBOARD_COLORS.text3}
          component="span"
        >
          {count}
        </TypographyCompo>
      ) : null}
    </div>
  );
});

export const CardTitle = memo(function CardTitle({ title }) {
  return (
    <TypographyCompo
      className="card-head-title"
      color={DASHBOARD_COLORS.text2}
      component="span"
    >
      {title}
    </TypographyCompo>
  );
});

export const StatusBadge = memo(function StatusBadge({ status, label }) {
  const badgeClass = STATUS_BADGE_MAP[status] || 'b-gray';
  return (
    <TypographyCompo className={`badge ${badgeClass}`} color="inherit" component="span">
      {label}
    </TypographyCompo>
  );
});

export const ProgressBar = memo(function ProgressBar({ label, value, width, color }) {
  return (
    <div className="bar-row">
      <div className="bar-meta">
        <TypographyCompo className="bar-lbl" color={DASHBOARD_COLORS.text2} component="span">
          {label}
        </TypographyCompo>
        <TypographyCompo component="span" fontWeight={600} color={color}>
          {value}
        </TypographyCompo>
      </div>
      <div className="bar-track">
        <div className="bar-fill" style={{ width, background: color }} />
      </div>
    </div>
  );
});

export const ActionButton = memo(function ActionButton({ icon, label }) {
  return (
    <button type="button" className="btn">
      <TypographyCompo className="btn-icon" color="inherit" component="span">
        {icon}
      </TypographyCompo>
      {label}
    </button>
  );
});

export const CardShell = memo(function CardShell({ title, children }) {
  return (
    <div className="card">
      {title ? (
        <div className="card-head">
          <CardTitle title={title} />
        </div>
      ) : null}
      {children}
    </div>
  );
});
